import React from "react";
import { useSelector } from "react-redux";
import Dashboard from "./Dashboard";
import PartnerLanding from "./PartnerLanding";

// Partners never see the estimation dashboard: /dashboard (the catch-all
// for any signed-in path without a page) opens their project instead.
export default function DashboardOrPartnerHome(props) {
  const partner = useSelector((s) => !!(s.user.userInfo && s.user.userInfo.partnerAccount));
  return partner ? <PartnerLanding {...props} /> : <Dashboard {...props} />;
}
